const data = {
  primaryColor: "#4caf50",
  lightColor: false,
  title: "Chemistry",
  category: "Education",
  icon: "/images/app-icons/chemistry.png",
  slogan: "Chemical elements, compounds and periodic table",
  fullDescription:
    "Chemistry is available for Android and as web application. Main feature is color-separated periodic table with detailed information about all known elements. Users can easily search for elements by name or symbol, and access information about each element. There is also a list of over 100 compounds, which can be searched by name or formula.",
  shortDescription:
    "Android and web application with color-separated periodic table, detailed information about elements and with over 100 compounds.",
  usesCases: [
    "Finding out information about element",
    "Finding out information about compounds",
    "Displaying periodic table",
  ],
  properties: [
    "Periodic table with groups that are color separated",
    "List of all known elements from periodic table with searching by name or symbol of element (Android only)",
    "Detail information about elements",
    "List of more than 100 compounds with searching by name of formula (Android only)",
    "Detail information about compounds (Android only)",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: null,
    requirements:
      "This application does not need any special requirements to run.",
    requiredAndroidVersion: "5.0 and up",
    versioning: {
      releasedOn: new Date(2018, 7, 12),
      currentVersion: "3.0.0",
      updatedOn: new Date(2023, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=cz.david_simak.chemistry",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: "SQLite",
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen with elements",
        url: "/images/project-screenshots/chemistry/chemistry-android-1.png",
        description: "Main screen with all elements from periodic table",
      },
      {
        title: "Main screen with compounds",
        url: "/images/project-screenshots/chemistry/chemistry-android-2.png",
        description: "Main screen with more than 100 compounds",
      },
      {
        title: "Detail screen of element",
        url: "/images/project-screenshots/chemistry/chemistry-android-3.png",
        description: "Detail screen of element",
      },
      {
        title: "Detail screen of radioactive element",
        url: "/images/project-screenshots/chemistry/chemistry-android-4.png",
        description: "Detail screen of radioactive element",
      },
      {
        title: "Detail screen of compound",
        url: "/images/project-screenshots/chemistry/chemistry-android-5.png",
        description: "Detail screen of compound",
      },
      {
        title: "Periodic table",
        url: "/images/project-screenshots/chemistry/chemistry-android-6.png",
        description: "Periodic table",
      },
      {
        title: "Element dialog",
        url: "/images/project-screenshots/chemistry/chemistry-android-7.png",
        description: "Dialog with basic information about element",
      },
    ],
  },
  frontend: {
    url: "https://chemistry.davidsimak.dev",
    versioning: {
      releasedOn: new Date(2018, 9, 1),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      libraries: ["axios", "rc-resize-observer"],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [
      {
        title: "Main screen with periodic table",
        url: "../../images/project-screenshots/chemistry/chemistry-web-1.png",
        description: "Periodic table",
      },
      {
        title: "Detail page of element",
        url: "../../images/project-screenshots/chemistry/chemistry-web-2.png",
        description: "Detail page of element",
      },
      {
        title: "Detail page of element",
        url: "../../images/project-screenshots/chemistry/chemistry-web-3.png",
        description: "Detail page of element",
      },
      {
        title: "Detail page of element",
        url: "../../images/project-screenshots/chemistry/chemistry-web-4.png",
        description: "Detail page of element",
      },
    ],
  },
  backend: null,
};

class ChemistryProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "chemistry",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new ChemistryProjectData();
